/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/no-unescaped-entities */

import React, { useEffect, useRef, useState } from "react";
import { FormControl, Button, TextInput } from "glic-ui-components";
import { ToastService } from "glic-ui-components";
import {
  faCheckCircle,
  faExclamationCircle,
} from "glic-ui-components/dist/icons";
import "./index.scss";
import { GLIC_API } from "../../../utils/API/glicAPI";
import { FLAGS } from "../../../utils/Constants";
import AlertBanner from "../../../components/AlertBanner";
import { setDomainUrl, getApiData, codeSnippetFunc } from "../../../utils/commonFunctions";
import Header from "../../../components/Header";
import metaLogo from "../../../assets/guardian.png";
import { Helmet } from "react-helmet";
import { v4 as uuidv4 } from "uuid";
import { includes } from "lodash";

const SecurityCode = (props) => {
  const { email = "", identityToken: token, userStatus, setNextStep } = props;
  const [disable, setDisable] = useState(false);
  const [showErrorBanner, setErrorBanner] = useState(false);
  const [otpApiData, setOtpApiData] = useState(null);
  const corelationId = uuidv4();
  const inputOtpRef = useRef();

  useEffect(() => {
    codeSnippetFunc('Page Viewed', 'Security Screen');
  }, []);

  const handleToast = async () => {
    try {
      const response = await GLIC_API.post(
        "/otpproxy/",
        { identityToken: `${token}` },
        true,
        { "Content-Type": "text/plain", "x-glic-request-id": corelationId }
      );
      if (response?.isTokenActive === "Y" && response?.isEmailSent === "Y") {
        ToastService.show("We’ve sent you an email with a new security code.", {
          type: "custom",
          fillColor: "GuardianMint",
          icon: faCheckCircle,
          ariaLabel: "We’ve sent you an email with a new security code.",
          className: "send-code",
        });
      } else {
        setErrorBanner(true);
        setOtpApiData(response);
      }
    } catch (err) {
      setErrorBanner(true);
    }
  };

  const verifyOTP = async () => {
    codeSnippetFunc('Form Step Completed', 'View ID Card Button', 'track');
    try {
      const body = {
        identityToken: `${token}`,
        otp: `${inputOtpRef.current.value}`,
      };
      const data = await getApiData("/verifyOTP/", body);
      const response = await data.json();
      if (response?.isTokenActive === "Y" && response?.isOtpValid === "Y") {
        if (includes(FLAGS.REGISTERED_USER_STATUS, userStatus)) {
          setNextStep(3);
        } else {
          const idcardsUrl = setDomainUrl(window.location.host);
          window.location.href = `${idcardsUrl}/welcome/${token}/idcard`;
        }
      } else if (
        response?.isTokenActive === "Y" &&
        response?.isOtpValid === "N"
      ) {
        ToastService.show(
          "The security code you entered is invalid or expired.",
          {
            type: "custom",
            fillColor: "white",
            icon: faExclamationCircle,
            ariaLabel: "The security code you entered is invalid or expired.",
            className: "error-toast",
          }
        );
      } else {
        setErrorBanner(true);
        setOtpApiData(response);
      }
    } catch (err) {
      setErrorBanner(true);
    }
  };

  const onBannerClose = (value) => {
    setErrorBanner(value);
  };

  const handleKeyDown = (event) => {
    if(event.key === 'Enter' && disable) {
      verifyOTP();
    }
  }

  return (
    <div>
      <Helmet>
        <title>Get Security code | Guardian</title>
        <link rel="icon" type="image/png" href={metaLogo} />
      </Helmet>
      <Header />
      {showErrorBanner ? (
        <AlertBanner
          setDisplayBanner={onBannerClose}
          errMsg={otpApiData?.status ?? ""}
        />
      ) : null}
      <div className="welcomeExperience__container" role="main">
        <div className="welcomeExperience__dob">
          <div className="welcomeExperience__bodyy">
            <h1 className="welcomeExperience__bodyHeading heading">
              For your security
            </h1>
            <div className="welcomeExperience__topContent">
              Verify your identity by entering the security code sent to{" "}
              {email.toLowerCase()}
            </div>
          </div>
          <div className="welcomeExperience__middleContent">
            <FormControl
              validations={{
                required: { message: "Please enter a security code" },
                regex: {
                  regex: /^\d+$/,
                  message: "Please enter a valid security code",
                },
                maxLength: {
                  maxLength: 6,
                  message: "The max length of the field is 6 digits",
                },
                minLength: {
                  minLength: 6,
                  message:
                    "The security code you entered is invalid or expired",
                },
              }}
              className="form-input"
              validateOnChange
              onValidate={(result) => {
                let res = result.some((e) => e["isValid"] === false);
                setDisable(!res);
              }}
            >
              <FormControl.Label className="headingTwo" id="securitycode-label">
                Security code (6 digits)
              </FormControl.Label>
              <TextInput
                className="searchInput"
                type="text"
                ref={inputOtpRef}
                id="securitycode"
                name="securitycode"
                aria-describedby="securitycode-label-error-message"
                maxLength="6"
                onKeyDown={handleKeyDown}
              />
            </FormControl>
          </div>
          <Button
            className={`${
              disable
                ? "welcomeExperience__nextButton"
                : "welcomeExperience__grayButton"
            }`}
            size="small"
            onClick={disable ? verifyOTP : null}
            isDisabled={!disable}
          >
            View ID card
          </Button>
          <div className="middleContent__footer">
            It may take a minute to receive your code. Haven’t received it?{" "}
            <button type="secondary" onClick={handleToast}>
              <u>Send another code</u>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecurityCode;